import React from 'react';
import { useRoutes } from 'react-router-dom';
import Home from 'pages/home/Home';
import NotFound from 'pages/notFound/NotFound';
import Rewards from 'pages/rewards/Rewards';
import Leaders from 'pages/leaders/Leaders';
import Sidebar from 'components/sidebar/Sidebar';
import Header from 'components/header/Header';

const App = (): JSX.Element => {
  const mainRoute = {
    path: '/',
    children: [
      // {path: '*', element: <Navigate to='/404' />},
      {path: '*', element: <NotFound />},
      {path: '/', element: <Home />},
    ],
  };

  const rewardsRoute = {
    path: 'rewards',
    element: <Rewards />,
  };

  const leadersRoute = {
    path: 'leaders',
    element: <Leaders />,
  };

  const routing = useRoutes([
    mainRoute,
    rewardsRoute,
    leadersRoute,
  ]);

  return (
    <div className="app">
      <Sidebar />
      <Header />
      {routing}
    </div>
  )
};

export default App;
